import CustomHead from 'components/commons/CustomHead'
import Template from 'components/mailmagazine-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const MailmagazineCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refMailmagazinePage')

  return (
    <>
      {fromCorrectFormPage ? (
        <CustomHead
          keyword={'内製化 内製化支援 Dev(Sec)Ops アジャイル開発 UIデザイン UXデザイン デザインスプリント'}
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/mailmagazine/thanks'}
          title="送信完了 メールマガジン | Aitria（アイトリア）"
          description="Aitria（アイトリア）のメールマガジン登録完了ページです。UX/UIデザイン・システム内製化・DX推進についてのお役立ちメソッドや、限定イベント、最新事例などをお届けします。"
          noindexNofollow={true}
        />
      ) : (
        <></>
      )}
      <Template />
    </>
  )
}

export default MailmagazineCompleted
